<template>
  <div id="app">
    <div v-if="isLoginPage">
      <router-view />
    </div>
    <div v-else>
      <el-container class="layout">
        <el-aside width="220px" class="app-aside">
          <div class="logo">医药商城后台</div>
          <el-menu class="side-menu" :default-active="activeMenu" router>
            <el-menu-item index="/products">
              <i class="el-icon-goods"></i>
              <span>商品维护</span>
            </el-menu-item>
            <el-menu-item index="/marketing">
              <i class="el-icon-present"></i>
              <span>营销策略</span>
            </el-menu-item>
            <el-menu-item index="/orders">
              <i class="el-icon-s-order"></i>
              <span>订单查看</span>
            </el-menu-item>
            <el-menu-item index="/banner">
              <i class="el-icon-picture"></i>
              <span>轮播图设置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <el-header class="app-header">
            <div class="header-title">医药微信小程序后台管理系统</div>
            <div class="header-actions"><el-button type="text" icon="el-icon-switch-button" @click="logout">退出登录</el-button></div>
          </el-header>
          <el-main class="app-main">
            <router-view />
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeMenu: this.$route.path
    }
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    }
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('wxshop_token')
      this.$router.replace('/login')
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.layout {
  height: 100vh;
  background: #f5f7fa;
}
.app-aside {
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eee;
  background: #fff;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 1px solid #eee;
}
.side-menu {
  flex: 1;
  border-right: none;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 0 16px;
}
.app-main {
  background: #f5f7fa;
  padding: 16px;
}
</style>
